import React, { useState } from 'react';
import { MDBTable, MDBTableHead, MDBTableBody, MDBIcon } from 'mdbreact';
import BarraEmpilhada from './BarraEmpilhada';
import { formataNumero } from './formata';

// Tabela agrupada genérica: grupos → linhas (expansíveis) → filhos.
// Não sabe o que é efetivo: recebe a/b/total e as duas séries ({rotulo, cor}).
//
// Escala ABSOLUTA e COMUM a unidades e alas: o maior total entre as unidades.
// Com uma escala por nível, a ala Alfa (18) tinha a barra do tamanho de
// Nhangapi (71) logo acima dela. O total geral não ganha barra — numa escala
// até 283 as unidades viram fiapos; a composição do total está no topo da tela.
//
// No celular a coluna da barra some: com ela, Demais e Total ficavam atrás de
// uma rolagem horizontal que nada indicava. Os números são o que se lê.
export default function TabelaUnidades({ grupos, series, total }) {
  const [abertas, setAbertas] = useState({});
  const alterna = (chave) => setAbertas((s) => ({ ...s, [chave]: !s[chave] }));
  const num = { textAlign: 'right', whiteSpace: 'nowrap' };
  // Cabeçalho quebra linha: "Força de segurança" em nowrap empurrava a tabela
  // para fora da tela no celular.
  const cab = { textAlign: 'right' };

  const linhas = grupos.reduce((acc, g) => acc.concat(g.linhas), []);
  const maxUnidade = Math.max(0, ...linhas.map((l) => l.total));

  const soma = (ls) =>
    ls.reduce((s, l) => ({ a: s.a + l.a, b: s.b + l.b, total: s.total + l.total }), { a: 0, b: 0, total: 0 });

  return (
    <MDBTable small responsive hover>
      <MDBTableHead>
        <tr>
          <th>Unidade</th>
          {series.map((sr) => (
            <th key={sr.rotulo} style={cab}>
              {/* `curto` no celular: "segurança" sozinho já alargava a coluna. */}
              <span className={sr.curto ? 'd-none d-sm-inline' : undefined}>{sr.rotulo}</span>
              {sr.curto ? <span className="d-sm-none">{sr.curto}</span> : null}
            </th>
          ))}
          <th style={cab}>Total</th>
          <th className="d-none d-sm-table-cell" style={{ width: '35%' }}>
            <span className="sr-only">Composição</span>
          </th>
        </tr>
      </MDBTableHead>
      <MDBTableBody>
        {grupos.filter((g) => g.linhas.length).map((g) => {
          const sub = soma(g.linhas);
          return (
            <React.Fragment key={g.titulo}>
              <tr className="grey lighten-4">
                <th colSpan={5} style={{ fontSize: '.8rem', letterSpacing: '.05em' }}>{g.titulo.toUpperCase()}</th>
              </tr>
              {g.linhas.map((l) => (
                <React.Fragment key={l.chave}>
                  <tr
                    onClick={l.filhos.length ? () => alterna(l.chave) : undefined}
                    style={l.filhos.length ? { cursor: 'pointer' } : undefined}
                  >
                    <td>
                      {/* Botão: a linha só abria com o mouse. Unidade sem ala não tem o que abrir. */}
                      {l.filhos.length ? (
                        <button
                          type="button"
                          className="btn btn-link p-0 m-0 mr-2"
                          style={{ fontSize: 'inherit', boxShadow: 'none', color: 'inherit' }}
                          aria-expanded={!!abertas[l.chave]}
                          aria-label={`${abertas[l.chave] ? 'Fechar' : 'Abrir'} as alas de ${l.rotulo}`}
                          onClick={(e) => { e.stopPropagation(); alterna(l.chave); }}
                        >
                          <MDBIcon icon={abertas[l.chave] ? 'caret-down' : 'caret-right'} />
                        </button>
                      ) : <span className="mr-2" style={{ display: 'inline-block', width: '.6em' }} />}
                      {l.rotulo}
                      {l.marca ? <small className="ml-2" style={{ color: 'var(--painel-alerta)' }}>{l.marca}</small> : null}
                    </td>
                    <td style={num}>{formataNumero(l.a)}</td>
                    <td style={num}>{formataNumero(l.b)}</td>
                    <td style={num}><strong>{formataNumero(l.total)}</strong></td>
                    <td className="d-none d-sm-table-cell" style={{ verticalAlign: 'middle' }}>
                      <BarraEmpilhada partes={[l.a, l.b]} series={series} max={maxUnidade} rotulo={l.rotulo} />
                    </td>
                  </tr>
                  {abertas[l.chave] && l.filhos.map((f) => (
                    <tr key={`${l.chave}-${f.chave}`} style={{ fontSize: '.85rem' }}>
                      <td style={{ paddingLeft: '2.2rem' }}>
                        {f.rotulo} <span className="text-muted">· {f.detalhe}</span>
                      </td>
                      <td style={num}>{formataNumero(f.a)}</td>
                      <td style={num}>{formataNumero(f.b)}</td>
                      <td style={num}>{formataNumero(f.total)}</td>
                      <td className="d-none d-sm-table-cell" style={{ verticalAlign: 'middle' }}>
                        <BarraEmpilhada partes={[f.a, f.b]} series={series} max={maxUnidade} rotulo={`${l.rotulo}, ${f.rotulo}`} />
                      </td>
                    </tr>
                  ))}
                </React.Fragment>
              ))}
              <tr className="text-muted">
                <td><em>Subtotal {g.titulo.toLowerCase()}</em></td>
                <td style={num}>{formataNumero(sub.a)}</td>
                <td style={num}>{formataNumero(sub.b)}</td>
                <td style={num}>{formataNumero(sub.total)}</td>
                <td className="d-none d-sm-table-cell" />
              </tr>
            </React.Fragment>
          );
        })}
        <tr>
          <th>TOTAL GERAL</th>
          <th style={num}>{formataNumero(total.a)}</th>
          <th style={num}>{formataNumero(total.b)}</th>
          <th style={num}>{formataNumero(total.total)}</th>
          <th className="d-none d-sm-table-cell" />
        </tr>
      </MDBTableBody>
    </MDBTable>
  );
}
